// By default dompurify will remove iframes, which we need for youtube links
// This solution is based upon: https://github.com/cure53/DOMPurify/issues/340#issuecomment-670758980
import createDOMPurify from "dompurify";
const DOMPurify = createDOMPurify(window);
const trustedDomains = [
    'youtube.com',
    'youtu.be',
    'youtube-nocookie.com',
    'vimeo.com'
];
DOMPurify.addHook("uponSanitizeElement", (node, data) => {
    var _a;
    if (data.tagName === "iframe") {
        const src = (_a = node.getAttribute("src")) !== null && _a !== void 0 ? _a : "";
        try {
            const url = new URL(src);
            const domain = url.hostname.replace('www.', '');
            // Check if the domain or any parent domain is in the trusted list
            const isDomainTrusted = trustedDomains.some(trustedDomain => domain === trustedDomain || domain.endsWith('.' + trustedDomain));
            if (!isDomainTrusted) {
                return node.parentNode.removeChild(node);
            }
        }
        catch (error) {
            // Invalid URL, remove the iframe
            return node.parentNode.removeChild(node);
        }
    }
});
export function sanitiseHtml(dirty) {
    return DOMPurify.sanitize(dirty, {
        ADD_TAGS: ["iframe"],
        ADD_ATTR: [
            "allow",
            "allowfullscreen",
            "webkitallowfullscreen",
            "mozallowfullscreen",
            "frameborder",
            "scrolling",
            "width",
            "height",
            "src",
            "title"
        ],
    });
}
export default sanitiseHtml;
